<div class="card-body">
    <div id="apex-distributed-column-chart"></div>
</div>